class MobileStickyBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const mobileStickyBar = this;
    const menuToggleElements = mobileStickyBar.querySelectorAll('[data-menu-mb-toggle]');
    const headerMenuIcon = document.querySelector('header .header__icon--menu');
    const msbCartIconBubble = document.querySelector('#msb-cart-icon-bubble');
    const cartIconBubble = document.querySelector('#cart-icon-bubble');

    if (menuToggleElements.length > 0 && headerMenuIcon) {
      $(document).off('click', '[data-menu-mb-toggle]').on('click', '[data-menu-mb-toggle]', (e) => {
        e.preventDefault();
        e.stopPropagation();
        headerMenuIcon.click();
      });
    }

    if (msbCartIconBubble && cartIconBubble) {
      $(document).off('click', '#msb-cart-icon-bubble').on('click', '#msb-cart-icon-bubble', (e) => {
        e.preventDefault();
        e.stopPropagation();
        cartIconBubble.click();
      });
    }
  }
}

// Define custom element
customElements.define('mobile-sticky-bar', MobileStickyBar);